<template>
	<div class="column-9 item">
		<h2>TODOS</h2>
		<div class="box-interacoes">
			<div class="lida">
				<i>
					<svg
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							width="21px" height="21px">
						<path fill-rule="evenodd" fill="rgb(7, 141, 0)"
								d="M10.500,-0.000 C4.701,-0.000 -0.000,4.701 -0.000,10.500 C-0.000,16.299 4.701,21.000 10.500,21.000 C16.299,21.000 21.000,16.299 21.000,10.500 C21.000,4.701 16.299,-0.000 10.500,-0.000 ZM15.032,5.844 L16.468,7.157 L8.593,15.873 L4.532,11.812 L5.906,10.437 L8.470,13.001 L15.032,5.844 L15.032,5.844 Z"/>
					</svg>
				</i>
				<span>Lida</span>
			</div>
			<div class="interacao">
				<i>
					<svg
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								width="21px" height="21px">
						<path fill-rule="evenodd" fill="rgb(231, 191, 0)"
									d="M10.500,21.000 C4.701,21.000 -0.000,16.299 -0.000,10.500 C-0.000,4.701 4.701,-0.000 10.500,-0.000 C16.299,-0.000 21.000,4.701 21.000,10.500 C21.000,16.299 16.299,21.000 10.500,21.000 ZM16.923,9.349 C16.887,9.304 16.870,9.249 16.828,9.207 L13.293,5.671 C12.707,5.086 11.757,5.086 11.172,5.671 C10.586,6.257 10.586,7.207 11.172,7.793 L12.304,8.925 L4.935,8.925 C4.065,8.925 3.360,9.630 3.360,10.500 C3.360,11.368 4.065,12.075 4.935,12.075 L12.304,12.075 L11.172,13.207 C10.586,13.793 10.586,14.743 11.172,15.328 C11.757,15.914 12.707,15.914 13.293,15.328 L16.828,11.793 C16.870,11.751 16.886,11.697 16.922,11.652 C17.236,11.364 17.440,10.959 17.440,10.500 C17.440,10.042 17.236,9.638 16.923,9.349 Z"/>
					</svg>
				</i>
				<span>Interação</span>
			</div>
			<div class="pendencia">
				<i>
					<svg
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								width="21px" height="21px">
						<path fill-rule="evenodd" fill="rgb(255, 0, 0)"
									d="M10.500,-0.000 C16.299,-0.000 21.000,4.701 21.000,10.500 C21.000,16.299 16.299,21.000 10.500,21.000 C4.701,21.000 -0.000,16.299 -0.000,10.500 C-0.000,4.701 4.701,-0.000 10.500,-0.000 ZM12.075,11.865 L12.075,4.935 C12.075,4.065 11.370,3.360 10.500,3.360 C9.632,3.360 8.925,4.065 8.925,4.935 L8.925,11.865 C8.925,12.735 9.630,13.440 10.500,13.440 C11.368,13.440 12.075,12.735 12.075,11.865 ZM10.500,14.490 C9.630,14.490 8.925,15.195 8.925,16.065 C8.925,16.935 9.630,17.640 10.500,17.640 C11.370,17.640 12.075,16.935 12.075,16.065 C12.075,15.195 11.370,14.490 10.500,14.490 Z"/>
					</svg>
				</i>
				<span>Pendência</span>
			</div>
		</div>
		<template v-for="(orcamento, key) in pedidos">
			<div class="box-overflow">
				<table class="padrao">
					<thead>
						<tr>
							<td colspan="3">Protocolo: {{ orcamento.protocolo }}</td>
							<td class="andamento">
								<i>
									<svg
												xmlns="http://www.w3.org/2000/svg"
												xmlns:xlink="http://www.w3.org/1999/xlink"
												width="20px" height="18px">
										<path fill-rule="evenodd" fill="rgb(255, 255, 255)"
													d="M3.586,11.536 C2.640,9.159 3.105,6.540 4.653,4.655 L4.638,5.709 L6.765,5.753 L6.846,1.078 L2.159,0.998 L2.115,3.121 L3.150,3.135 C1.008,5.614 0.341,9.133 1.608,12.319 C2.995,15.806 6.342,18.000 9.977,18.000 C10.590,18.000 11.212,17.937 11.834,17.808 L11.399,15.730 C8.111,16.414 4.825,14.650 3.586,11.536 ZM18.390,5.677 C16.769,1.603 12.469,-0.705 8.166,0.189 L8.600,2.267 C11.887,1.584 15.173,3.347 16.412,6.460 C17.358,8.839 16.893,11.460 15.344,13.346 L15.357,12.283 L13.229,12.243 L13.157,16.917 L17.843,16.989 L17.883,14.867 L16.856,14.854 C18.993,12.376 19.656,8.860 18.390,5.677 Z"/>
									</svg>
								</i>
								<span v-if="orcamento.ultimo_status.slug === 'enviado' && !orcamento.cliente.from_sap && !orcamento.cliente.codigo">
                  {{orcamento.ultimo_status.titulo}} - Cliente Novo
                </span>
                <span v-else>
                  {{orcamento.ultimo_status.titulo}}
                </span>
							</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td colspan="4">
								<table>
									<tr>
										<td colspan="1"><b>Interações:</b></td>
										<td class="td-interacoes">
											<i>
												<svg 
															v-if="orcamento.lido.lido"
															xmlns="http://www.w3.org/2000/svg"
															xmlns:xlink="http://www.w3.org/1999/xlink"
															width="21px" height="21px">
													<path fill-rule="evenodd" fill="rgb(7, 141, 0)"
																d="M10.500,-0.000 C4.701,-0.000 -0.000,4.701 -0.000,10.500 C-0.000,16.299 4.701,21.000 10.500,21.000 C16.299,21.000 21.000,16.299 21.000,10.500 C21.000,4.701 16.299,-0.000 10.500,-0.000 ZM15.032,5.844 L16.468,7.157 L8.593,15.873 L4.532,11.812 L5.906,10.437 L8.470,13.001 L15.032,5.844 L15.032,5.844 Z"/>
												</svg>
												<svg
															v-else
															xmlns="http://www.w3.org/2000/svg"
															xmlns:xlink="http://www.w3.org/1999/xlink"
															width="21px" height="21px">
													<path fill-rule="evenodd" fill="rgb(231, 191, 0)"
																d="M10.500,21.000 C4.701,21.000 -0.000,16.299 -0.000,10.500 C-0.000,4.701 4.701,-0.000 10.500,-0.000 C16.299,-0.000 21.000,4.701 21.000,10.500 C21.000,16.299 16.299,21.000 10.500,21.000 ZM16.923,9.349 C16.887,9.304 16.870,9.249 16.828,9.207 L13.293,5.671 C12.707,5.086 11.757,5.086 11.172,5.671 C10.586,6.257 10.586,7.207 11.172,7.793 L12.304,8.925 L4.935,8.925 C4.065,8.925 3.360,9.630 3.360,10.500 C3.360,11.368 4.065,12.075 4.935,12.075 L12.304,12.075 L11.172,13.207 C10.586,13.793 10.586,14.743 11.172,15.328 C11.757,15.914 12.707,15.914 13.293,15.328 L16.828,11.793 C16.870,11.751 16.886,11.697 16.922,11.652 C17.236,11.364 17.440,10.959 17.440,10.500 C17.440,10.042 17.236,9.638 16.923,9.349 Z"/>
												</svg>
												<svg
															v-if="orcamento.prazo_resposta"
															xmlns="http://www.w3.org/2000/svg"
															xmlns:xlink="http://www.w3.org/1999/xlink"
															width="21px" height="21px">
													<path fill-rule="evenodd" fill="rgb(255, 0, 0)"
																d="M10.500,-0.000 C16.299,-0.000 21.000,4.701 21.000,10.500 C21.000,16.299 16.299,21.000 10.500,21.000 C4.701,21.000 -0.000,16.299 -0.000,10.500 C-0.000,4.701 4.701,-0.000 10.500,-0.000 ZM12.075,11.865 L12.075,4.935 C12.075,4.065 11.370,3.360 10.500,3.360 C9.632,3.360 8.925,4.065 8.925,4.935 L8.925,11.865 C8.925,12.735 9.630,13.440 10.500,13.440 C11.368,13.440 12.075,12.735 12.075,11.865 ZM10.500,14.490 C9.630,14.490 8.925,15.195 8.925,16.065 C8.925,16.935 9.630,17.640 10.500,17.640 C11.370,17.640 12.075,16.935 12.075,16.065 C12.075,15.195 11.370,14.490 10.500,14.490 Z"/>
												</svg>
											</i>
											<div class="box-check" v-if="orcamento.lido.lido && orcamento.lido.origem == 'representante'" @click="notRead(orcamento.id, key)">
												<input class="styled-checkbox" type="checkbox" 
													:value="orcamento.id">
												<label>Marcar como não lida</label>
											</div>
										</td>
										<td colspan="1"><b>Data Criação:</b></td>
										<td>
											{{ orcamento.created_at }}
										</td>
									</tr>
								</table>
							</td>
						</tr>
						<tr>
							<td colspan="4">
								<table>
									<tr>
										<td colspan="1"><b>Código / Cliente:</b></td>
										<td>
											{{ orcamento.cliente.codigo}} / {{ orcamento.cliente.nome }}
										</td>
										<td>
											<b>Valor total do Pedido:</b>
										</td>
										<td v-if="orcamento.ultimo_status.slug !== 'orcamento-enviado-preposto' || orcamento.cliente_tipo_venda">
											<span v-if="orcamento.orcado || orcamento.cliente_tipo_venda">R$ {{ orcamento.total | currency }}</span>
										</td>
										<td v-else></td>
									</tr>
								</table>
							</td>
						</tr>
						<tr>
							<td colspan="4">
								<table>
									<tr>
										<td colspan="1"><b>Empresa Representante:</b></td>
										<td>
											{{ orcamento.representante }}
										</td>
										<td>
											<b>Prazo de Resposta:</b>
										</td>
										<td>{{ orcamento.prazo_resposta}}</td>
									</tr>
								</table>
							</td>
						</tr>
						<tr v-if="Object.keys(orcamento.entrega).length">
              <td colspan="4">
                <table>
                  <tr>
                    <td colspan="1"><b>Status de Entrega:</b></td>
                    <td colspan="3">
                      <span>{{orcamento.status_entrega_atual.statusText}} </span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr v-if="Object.keys(orcamento.entrega).length">
              <td colspan="4">
								<table>
									<tr>
										<td colspan="1" v-if="orcamento.status_entrega_atual.status == 'delivered'"><b>Data de Entrega:</b></td>
                    <td colspan="1" v-else><b>Previsão de Entrega até:</b></td>
										<td colspan="2">
                      <span>{{orcamento.status_entrega_atual.deliveryDate}} </span>
										</td>
                    <td colspan="1">
                      <a data-fancybox data-src="#modal-delivery" href="javascript:;" @click="changeDeliveryItem(orcamento.entrega)" class="show-deliveries" :style="{backgroundColor: orcamento.status_entrega_atual.color}">
                        <i class="fa fa-truck fa-1x"></i> Informações de entrega
                      </a>
                    </td>
									</tr>
								</table>
							</td>
						</tr>

					</tbody>
				</table>
				<div class="btn-group">
					<a :href="root + '/meus-pedidos/detalhes/' + orcamento.id" class="btn-padrao">+ detalhes</a>
					<a v-if="orcamento.rascunho_cliente == 0 || orcamento.ultimo_status.titulo == 'Cancelado'" :href="root +  '/meus-pedidos/similar/' + orcamento.id" class="btn-padrao">Criar orçamento similar</a>
					<a v-else :href="root + '/meus-pedidos/continuar/' + orcamento.id" class="btn-padrao">Continuar Orçamento</a>
				</div>
			</div>
		</template>
		<div v-if="!loading">
			<infinite-loading ref="infinite" @infinite="infiniteHandler">
				<div slot="spinner">
					<vue-element-loading :active="true" spinner="bar-fade-scale"/>
				</div>
				<div style="font-size: 0.9em" slot="no-results">
					<small v-if="pedidos.length === 0">Nenhum resultado encontrado</small>
					<small v-else>Total de registros carregados: {{pedidos.length}}</small>
				</div>
				<div style="font-size: 0.9em" slot="no-more">
					<small>Total de registros carregados: {{pedidos.length}}</small>
				</div>
			</infinite-loading>
		</div>
		<vue-element-loading :active="loadingSave" is-full-screen></vue-element-loading>  
        <div style="display: none;" id="modal-delivery" class="modal-delivery">
          <div class="content">
            <div class="column-12 ">
              <h1>Informações de entrega</h1>
            </div>
            <template v-for="(delivery, index) in this.deliveries">
              <table class="padrao margin20-top" >
                <thead>
                <tr>
                  <td colspan="2">Nota Fiscal {{ delivery.orderNumber }}</td>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Data emissão da nota:</td>
                  <td>{{ delivery.orderDate }}</td>
                </tr>
                <tr>
                  <td v-if="delivery.status ==='delivered'">Data de entrega:</td>
                  <td v-else >Data previsão entrega até:</td>
                  <td>{{delivery.deliveryDate}}</td>
                </tr>
                <tr>
                  <td>Transportadora:</td>
                  <td>{{delivery.carrier}}</td>
                </tr>
                <tr>
                  <td>Status da Entrega:</td>
                  <td>{{delivery.statusText}}</td>
                </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>
	</div>

</template>
<script>
	import formatMixin from '../../../../../../../../../resources/assets/js/mixins/formatMixin';

	export default
    {
			mixins: [formatMixin],
			props : {
				filtros: [Object, Array]
			},
			data() {
				return {
					pedidos: [],
					request: {page: 1},
					loading: false,
					loadingSave: false,
					root: APP_URL,
					deliveries: []
				};
			},
			methods: {
				infiniteHandler($state = { loaded() {}, complete() {} })
				{
					this.axios.post(API_URL + '/meus-pedidos/filtro', this.request)
					.then(({data}) =>
					{

					if (data.data.length > 0)
						{

							this.pedidos = this.pedidos.concat(data.data);
							this.request.page++;
							$state.loaded();
						}
						else
						{
							$state.complete();
						}

						if (this.loading)
						{
							this.loading = false;
						}
					})
				},
				buscar(filtros)
				{
						this.request.page = 1;
						this.request = this.extend(this.request, filtros);
						this.loading = true;
						this.pedidos = [];
						this.infiniteHandler();
				},
				status(status)
				{
						this.request.page = 1;
						this.request.tipo = status;
						this.pedidos = [];
						this.loading = true;
						this.infiniteHandler();
				},
				toggleNotes(target) {

					$('#btBalao' + target).toggleClass("expand");

					$('#balao' + target).slideToggle(300, function () {
							$.fn.matchHeight._update()
					});
				},
				saveNotes(budget, key) {
					var vm = this;
					this.loadingSave = true;
					this.axios
						.post(API_URL + "/meus-pedidos/salvar-anotacao", {
							pedido: budget,
							note: this.pedidos[key].notas_cliente
						})
						.then(function(response) {
							vm.savingSuccessful = true;
							vm.loadingSave = false;
							$('#balao' + budget).hide();
						})
						.catch(function(error) {
							vm.savingError = true;
							vm.loadingSave = false;
						});
				},
				notRead(pedidoId, key) {
					var vm = this;
					this.loadingSave = true;
					this.axios
						.post(API_URL + "/meus-pedidos/nao-lido", {
							pedido: pedidoId
						})
						.then(function(response) {
							vm.loadingSave = false;
							vm.pedidos[key].lido.lido = false;
						})
						.catch(function(error) {
							vm.loadingSave = false;
						});
				},
				changeDeliveryItem(deliveries) {
					this.deliveries = deliveries
				}
			},
			mounted() {
				if (this.filtros) {
					this.request.page = 1;
					switch (this.filtros.status) {
						case 'pendencias' : this.request.pendencias = true; break;
						case 'andamento' : this.request.andamento = true; break;
						case 'cancelados' : this.request.cancelados = true; break;
						case 'concluidos' : this.request.concluidos = true; break;
					}
				}
				this.loading = true;
				this.buscar(this.filtros);
			}
    };
</script>